import { eventEmitter } from "@/utils/event-emitter.js";

export function changeTheme() {
  eventEmitter.on("changeTheme", () => {
    document.body.classList.toggle("light");
  });
}
